export interface SearchResult {
  title: string;
  description: string;
  url: string;
  type: 'page' | 'article' | 'resource';
}

export const performSiteSearch = (query: string): SearchResult[] => {
  // This is a simplified search implementation
  // In a real application, this would typically connect to a backend search service
  const siteContent: SearchResult[] = [
    {
      title: "Getting Started Guide",
      description: "Learn how to get started with our platform and digital human care solutions",
      url: "/knowledge-base/getting-started",
      type: "article"
    },
    {
      title: "Platform Overview",
      description: "Comprehensive overview of the Scienza Health platform features and capabilities",
      url: "/knowledge-base/platform-overview",
      type: "article"
    },
    {
      title: "Assessment Guide",
      description: "Detailed guide on conducting and interpreting cognitive assessments",
      url: "/knowledge-base/assessment-guide",
      type: "article"
    },
    {
      title: "Care Planning",
      description: "Best practices for creating and managing care plans",
      url: "/knowledge-base/care-planning",
      type: "article"
    },
    {
      title: "Video Tutorials",
      description: "Step-by-step video guides for using the platform",
      url: "/knowledge-base/video-tutorials",
      type: "resource"
    },
    {
      title: "Contact Support",
      description: "Get help from our support team",
      url: "/support",
      type: "page"
    },
    {
      title: "Enterprise Solutions",
      description: "Learn about our enterprise-level memory care solutions",
      url: "/enterprise",
      type: "page"
    },
    {
      title: "Family Resources",
      description: "Resources and guides for family caregivers",
      url: "/family",
      type: "resource"
    },
    {
      title: "Technology Overview",
      description: "Explore our AI and digital human technology",
      url: "/technology",
      type: "page"
    },
    {
      title: "Research & Development",
      description: "Latest developments in memory care technology",
      url: "/learn-more",
      type: "article"
    }
  ];

  if (!query) return [];

  const normalizedQuery = query.toLowerCase();
  return siteContent.filter(
    item =>
      item.title.toLowerCase().includes(normalizedQuery) ||
      item.description.toLowerCase().includes(normalizedQuery)
  );
};